import { Clerk } from '@clerk/clerk-js/headless';
import { clerkPublishableKey } from '@/config-global';

let clerkInstance: Clerk | null = null;

if (typeof window !== 'undefined') {
  // Only create the instance when we're in the browser
  clerkInstance = new Clerk(clerkPublishableKey);
}

export { clerkInstance };

// If no instance exists (e.g. during SSR), resolve immediately.
export const clerkLoadedPromise = clerkInstance
  ? clerkInstance.load()
  : Promise.resolve();

//
